/*=========================================================================================
  File Name: moduleAuth.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import mutations from "./moduleNotificationVerifyMutations";
import actions from "./moduleNotificationVerifyActions";
import getters from "./moduleNotificationVerifyGetters";

export default {
  namespaced: true,
  state: "",
  mutations: mutations,
  actions: actions,
  getters: getters
};
